import{createContext}from'react';var LazyContext=createContext({strict:false});export{LazyContext};